<template>

    <div class="canvas::editor-admin-Canvas relative"
         :class="activeMode === 'overview' ? 'w-1/3' : 'w-full'"
         ref="canvas"
    >

        <div class="absolute top-5 left-5 z-50"
             v-show="activeMode === 'content'">

            <button
                v-show="copiedBlockId !== null"
                ref="pasteCanvasBlockButton"
                :class="{ 'opacity-50 pointer-events-none': pastingBlock }"
                class="inline-flex items-center px-5 py-2 border transition border-transparent text-sm leading-4 font-medium rounded-md text-indigo-700 bg-indigo-100 bg-opacity-50 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                v-on:click="pasteCanvasBlock(canvasVersion)"
            >
                <svg v-show="pastingBlock" class="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span class="font-medium text-lg leading-normal mb-0">Plak blok</span>
            </button>

            <button
                v-show="copiedBlockId !== null"
                ref="removePasteCanvasBlockButton"
                :class="{ 'opacity-50 pointer-events-none': pastingBlock }"
                class="inline-flex items-center px-5 py-2 ml-4 border transition border-transparent text-sm leading-4 font-medium rounded-md text-indigo-700 bg-indigo-100 bg-opacity-50 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                v-on:click="removeCopiedBlock();"
            >
                <span class="font-medium text-lg leading-normal mb-0">Verwijder klembord</span>
            </button>

        </div>

        <button
            v-show="activeMode === 'overview' && primaryLanguage !== language"
            ref="importBlocksBtn"
            class="block w-full border-2 border-dashed border-indigo-300 hover:bg-indigo-400 hover:border-transparent hover:text-white px-5 py-5 rounded text-center text-gray-500 transition-all"
            v-on:click="importCanvasBlocks(canvasVersion)"
        >
            <span class="font-medium text-lg leading-normal mb-0">Importeer blokken van primaire taal ({{ primaryLanguage }})</span>
        </button>

        <div
            v-if="activeMode === 'overview' && (canvasVersion.canvas_blocks.length == 0 || addInstruction.show)"
            class="bg-white border-1 border-gray-500 py-5 px-5 text-center m-3 addInstruction"
            :class="{
                    saving: stateSaving,
                    hoveredForAddBlock: addInstruction.hoveredForAddBlock,
                }"
            @dragover.prevent="addInstruction.hoveredForAddBlock = true"
            @dragleave.prevent="addInstruction.hoveredForAddBlock = false"
            @drop.prevent="onInstructionDrop">

            <h5 class="font-medium text-lg leading-normal mb-0">Drag &amp; drop een blok<br/>van rechts</h5>
            <div class="text-xs mt-1">(of klik het aan)</div>

        </div>

        <div
            v-if="activeMode == 'content' && canvasVersion.canvas_blocks.length == 0"
            class="bg-gray-50 border-1 border-gray-500 text-center absolute inset-0 z-10 flex justify-center items-center">

            <div class="flex flex-col items-center">
                <svg class="w-32 h-32 text-gray-400 mb-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"></path></svg>
                <h6 class="text-xl text-gray-400">Ga naar het overzicht om een blok toe te voegen</h6>
            </div>

        </div>

        <div
            class="zoomer"
            :style="{
                    transform: 'scale(' + scale + ')',
                    width: (100 / scale) + '%',
                    height: 'calc(' + (100 / scale) + '% - '+ (
                        activeMode === 'overview' && primaryLanguage !== language
                            ? ($refs.canvas.clientHeight / $refs.importBlocksBtn.clientHeight * 100) + 30
                            : 0) +'px' +
                        ')'
                 }">

            <div
                class="h-full"
                :style="{
                        padding: activeViewport != 'xl' ? (24 / scale) + 'px ' + (16 / scale) + 'px' : 0,
                    }">

                <div class="h-full m-auto"
                     :style="{
                        maxWidth: activeMode != 'overview' ? viewportWidth + 'px' : '100%',
                     }">

                    <document-iframe
                        ref="iframe"
                        v-show="activeMode == 'content' || (activeMode == 'overview' && canvasVersion.canvas_blocks.length > 0)"
                        :canvasVersion="canvasVersion"
                        :scale="scale"
                        :activeMode="activeMode"
                        @loaded="$emit('loaded')"/>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import DocumentIframe from "./DocumentIframe";
import delay from "delay";

// TODO Rename Canvas to ..?
export default {

    provide: function ()
    {
        return {
            canvasComponent: this,
        };
    },

    components: {
        DocumentIframe,
    },

    props: {
        canvasVersion: Object,

        activeMode: String,
        activeViewport: String,

        language: String,
        primaryLanguage: String,

        stateSaving: Boolean,
        galleryDraggingBlock: Object,
    },

    data()
    {
        return {
            scale: 1,

            selection: {
                hovers: [],
                focus: {
                    component: null,
                    extra: null,
                },
            },

            addInstruction: {
                show: false,
                hoveredForAddBlock: false,
            },

            pastingBlock: false,
            copiedBlockId: null,
        };
    },

    mounted()
    {
        this.manageScale();
        this.updateCopiedBlockData();
    },

    methods:
    {
        async importCanvasBlocks(canvasVersion)
        {
            if( this.canvasVersion.canvas_blocks.length !== 0 ) {
                await Swal.fire({
                    title: 'Weet u het zeker?',
                    text: 'Je kan er voor kiezen om alle huidige blokken te verwijderen of alleen de blokken van de andere taal toe te voegen zonder de huidige te verwijderen.',
                    showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonText: 'Ja, bewaren',
                    confirmButtonColor: '#55ce62',
                    denyButtonText: 'Overschrijven',
                    cancelButtonText: 'Annuleren',
                }).then((result) => {
                    if(result.isConfirmed) {
                        this.importCanvasBlockPost(true, canvasVersion);
                    } else if(result.isDenied) {
                        this.importCanvasBlockPost(false, canvasVersion);
                    }
                })
            } else {
                await this.importCanvasBlockPost(true, canvasVersion);
            }
        },

        async importCanvasBlockPost(keepCurrentBlocks = true, canvasVersion)
        {
            let url = '/canvas/'+ ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') +'modules/canvas/'+canvasVersion.canvas_id+'/import-blocks';

            await axios.post(url, {
                'keepCurrentBlocks': keepCurrentBlocks,
                'language': $('html').attr('lang'),
            })
                .then(() => {
                    // TODO Medium: Update reactively?
                    window.location.reload();
                });
        },

        manageScale()
        {
            // No scaling on canvas?
            if (this.activeMode != 'overview')
                this.scale = 1;

            // Set scale to show an lg page?
            else
                this.scale = Math.min($(this.$el).width() / 1500, 1);
        },

        onInstructionDrop()
        {
            // @ugly Call iframe
            this.$refs['iframe'].iframeApp.pageComponent.state.canvasVersion.canvas_blocks.push({
                block: this.galleryDraggingBlock.id,
                options: { ...this.galleryDraggingBlock.options, ...this.galleryDraggingBlock.defaultOptions }
            });
        },

        async pasteCanvasBlock(canvasVersion) {
            this.pastingBlock = true;

            let url = '/canvas/' + ($('html').data('prefix') !== undefined
                    ? $('html').data('prefix')
                    : 'admin/'
            ) + 'modules/canvas/' + canvasVersion.canvas_id + '/paste-block/' + this.getCopiedBlock();

            try {
                await axios.post(url)
                    .then(async (requestData) => {
                        if (requestData.data.success === false) {
                            this.$toasted.show(requestData.data.message, {
                                duration: 3000,
                                type: 'error',
                                iconPack: 'fontawesome',
                                closeOnSwipe: false,
                            });
                        } else {
                            await this.$refs['iframe'].iframeApp.pageComponent.state.refresh();

                            this.$refs['iframe'].iframeApp.pageComponent.scrollToLastBlock();

                            this.$toasted.show('Het gekopieerde blok is toegevoegd als laatste blok in dit canvas!', {
                                duration: 5000,
                                type: 'success',
                                iconPack: 'fontawesome',
                                closeOnSwipe: false,
                            });
                        }
                    });
            } catch (e) {
                console.error('Could not paste block: ' + e.error.message + '. This is probably because of a routing issue.');

                this.$toasted.show('Er is iets misgegaan met het kopieren van het blok. Probeer het opnieuw of neem contact op met de website eigenaar.', {
                    duration: 3000,
                    type: 'error',
                    iconPack: 'fontawesome',
                    closeOnSwipe: false,
                });
            }

            this.pastingBlock = false;
        },

        getCopiedBlock() {
            return window.localStorage.getItem('galaxy.admin.canvas.copyBlockId');
        },

        removeCopiedBlock() {
            window.localStorage.removeItem('galaxy.admin.canvas.copyBlockId');

            this.copiedBlockId = null;
        },

        async updateCopiedBlockData() {
            if (this.getCopiedBlock() !== this.copiedBlockId) {
                this.copiedBlockId = this.getCopiedBlock();
            }

            await delay(250);
            await this.updateCopiedBlockData();
        },

    },

    computed: {

        instance()
        {
            return this;
        },

        viewportWidth()
        {
            // Full width due to XL?
            if (this.activeViewport === 'xl') {
                return 10000;
            }

            // @ugly Assuming it will always be website where canvas blocks will be shown.
            // TODO Medium: Setup per canvas to determine which Concord module will be used.
            // Grab tailwind config for screens
            let tailwindConfig = require('@app/tailwind.config.website.js');
            let requiredScreens = {
                'xs': '375px',
                'sm': '640px',
                'md': '768px',
                'lg': '1024px',
                'xl': '1280px',
            }

            // Set default widths if not configured in config
            if (tailwindConfig.theme.screens === undefined) {
                tailwindConfig.theme.screens = requiredScreens;
            } else {
                for (const [key, value] of Object.entries(requiredScreens)) {
                    if (tailwindConfig.theme.screens[key] !== undefined) {
                        continue;
                    }

                    tailwindConfig.theme.screens[key] = value;
                }
            }

            // Get activeViewport screen size from tailwind config to get correct viewport px
            return parseInt(tailwindConfig.theme.screens[this.activeViewport].split('px')[0]);
        },

    },

    watch: {

        async 'activeMode'()
        {
            // @ugly To be able to get the correct new width.
            await delay(1);

            this.manageScale();
        },

        /* TODO Low: See " // Keep showing add .."
        'canvasVersion.id'()
        {console.error('canvasVersion.id watcher');

            // Hide instruction by default.
            this.addInstruction.show = false;
        },

        'canvasVersion.canvas_blocks'(newVal, oldVal)
        {
            console.info('canvasVersion.canvas_blocks watchere');

            // Keep showing add instruction while saving the first block? Our state tells us we already have 1 block, but it is not visible on the screen yet.
            if(oldVal.length == 0 && newVal.length == 1)
                this.addInstruction.show = true;
        },
        */

        'stateSaving'(newVal)
        {
            // Hide show add?
            if (this.canvasVersion.canvas_blocks.length > 0 && !newVal)
                this.addInstruction.show = false;
        }
    }

}

</script>

<style lang="scss" scoped>

.canvas\:\:editor-admin-Canvas {
    background: #ecf0f1;

    .addInstruction {
        border: 3px solid white;

        &.saving {
            cursor: wait;
            opacity: .6;
            transition: opacity .2s;

            > * {
                pointer-events: none;
            }
        }

        &.hoveredForAddBlock {
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.12), 0 0px 6px rgba(0, 0, 0, 0.12);
            border-color: #0888c8;
        }

    }

    .zoomer {
        transform-origin: left top;
    }

}

</style>
